// Shared display-layer constants used by both ModalityApp (prop-drilled
// into AdminPanel) and the useDisplaySettings hook's derived values.

export const gradientPresets = [
  { name: 'Default',      colors: ['#314e4a', '#2c4440', '#2a5a54', '#4a7872'] },
  { name: 'Oceanic',      colors: ['#003973', '#004d8c', '#0060a3', '#0073b9'] },
  { name: 'Sunset',       colors: ['#ff7e5f', '#feb47b', '#ffb88c', '#ffd6a5'] },
  { name: 'Lush',         colors: ['#134e5e', '#1e6b82', '#71b280', '#96c49f'] },
  { name: 'Twilight',     colors: ['#485563', '#29323c', '#505c68', '#757f8a'] },
  { name: 'Amethyst',     colors: ['#9d50bb', '#6e48aa', '#825ba8', '#a87ac1'] },
  { name: 'Aurora',       colors: ['#1e3c72', '#2a5298', '#7e57c2', '#ec407a'] },
  { name: 'Ember',        colors: ['#3a1c1c', '#7f1d1d', '#c2410c', '#f59e0b'] },
  { name: 'Forest',       colors: ['#0b3d2e', '#14532d', '#166534', '#3f6212'] },
  { name: 'Midnight',     colors: ['#020617', '#0f172a', '#1e1b4b', '#312e81'] },
  { name: 'Peachy',       colors: ['#ff9a8b', '#ff6a88', '#ff99ac', '#fad0c4'] },
  { name: 'Mint',         colors: ['#0f766e', '#14b8a6', '#5eead4', '#a7f3d0'] },
  { name: 'Slate',        colors: ['#1f2937', '#374151', '#4b5563', '#6b7280'] },
  { name: 'Cotton Candy', colors: ['#fbc2eb', '#a6c1ee', '#fad0c4', '#fbc2eb'] },
  { name: 'Custom',       colors: [] },
];

export const ANIMATION_STYLES = [
  { id: 'flow',    label: 'Flow',    className: 'animate-gradient'         },
  { id: 'pulse',   label: 'Pulse',   className: 'animate-gradient-pulse'   },
  { id: 'drift',   label: 'Drift',   className: 'animate-gradient-drift'   },
  { id: 'shimmer', label: 'Shimmer', className: 'animate-gradient-shimmer' },
  { id: 'static',  label: 'Static',  className: 'animate-gradient-static'  },
];

export const PATTERN_STYLES = [
  { id: 'none',  label: 'None',  className: 'pattern-none'  },
  { id: 'dots',  label: 'Dots',  className: 'pattern-dots'  },
  { id: 'grid',  label: 'Grid',  className: 'pattern-grid'  },
  { id: 'blobs', label: 'Blobs', className: 'pattern-blobs' },
];
